import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { AvailableFilterOptionDto } from './available-filter-option-dto.type';

const SearchBookmarkDto = t.type(
  {
    id: t.string,
    name: nullable(t.string),
    globalFilters: nullable(t.array(AvailableFilterOptionDto)),
    filters: nullable(t.array(AvailableFilterOptionDto)),
  },
  'SearchBookmarkDto',
);

type SearchBookmarkDto = t.TypeOf<typeof SearchBookmarkDto>;
export { SearchBookmarkDto };
